import styled, { css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon, blue } = colorsPalettes;

export const ProjectWrapper = styled(FlexRow)<{ isLoading?: boolean }>`
    position: relative;
    height: 46px;
    padding: 16px;
    background: ${carbon[0]};
    border: 1px solid ${carbon[50]};
    border-radius: 3px;
    align-items: center;
    gap: 16px;

    &:hover {
        box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);

        .hidden-icon {
            display: block;
        }

        .alertsIndicationButton {
            background: ${rgba(carbon[200], 0.2)};

            & > div {
                color: ${blue[500]};
            }
        }

        ${({ isLoading }) =>
            isLoading
                ? css`
                      cursor: not-allowed;
                  `
                : css`
                      z-index: 99;
                      border: 1px solid ${carbon[100]};
                      cursor: pointer;
                  `}
    }
`;

export const Separator = styled.div`
    height: 40px;
    border-right: 1px solid ${carbon[100]};
`;

export const ShareContainer = styled(FlexRow)`
    box-sizing: border-box;
    width: max-content;
    margin-right: 8px;
`;

export const IconsGroupContainer = styled.div`
    transform: translate(0px, 10px);
    height: 100%;
    position: relative;
    width: 35px;

    div {
        top: 10px;
        left: 20px;
    }

    .ItemIcon {
        position: absolute;
        width: 24px;
        height: 24px;
        margin: 0;
        top: 10px;
        left: 10px;

        &:first-child {
            top: 0;
            left: 0;
        }
    }
`;
export const NameGroup = styled(FlexRow)`
    width: 100%;
    min-width: 40%;
    gap: 16px;
`;
